export default "__VITE_ASSET__CGc2o4h4__"